import {gql} from '@apollo/client';

export const LOGOUT_USER_MUTATION = gql`
  mutation LogoutUserMutation {
    logout {
      errors
      loggedOut
    }
  }
`;
